import { render, staticRenderFns } from "./noticia.vue?vue&type=template&id=08ae55bc&scoped=true"
import script from "./noticia.vue?vue&type=script&lang=js"
export * from "./noticia.vue?vue&type=script&lang=js"
import style0 from "./noticia.vue?vue&type=style&index=0&id=08ae55bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae55bc",
  null
  
)

export default component.exports